import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import get from 'lodash/get';
import { c as classnames } from './index-2586sEvh.js';
import './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-sNwiaBfD.js';
import 'next/router';
import useOutsideClick from './hooks/useOutsideClick.js';
import 'notistack';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { S as Skeleton } from './Skeleton-RKr5mJai.js';
import EmptyMessage from './components/EmptyMessage/index.js';
import { I as InputAutocompleteOption } from './InputAutocompleteOption-ZBLmHamR.js';

/* eslint-disable react/no-array-index-key */
const InputAutocomplete = ({ setValue, errors, control, name, pending, options = [], label = '', disabled, placeholder = '', controlClassName, inputClassName, charactersMinLength, filled = false, inputMode, onChangeCallback, onSelectCallback, onResetCallback, }) => {
    const { t } = useTranslation('');
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const [focusedElementIndex, setFocusedElementIndex] = useState(null);
    const [isListOpened, setIsListOpened] = useState(false);
    const errorText = get(errors, `${name}.message`, '');
    const ref = useOutsideClick(() => setIsListOpened(false));
    const onInputChange = (changeEvent, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange) => {
        onChange(changeEvent);
        setIsListOpened(true);
        setFocusedElementIndex(null);
        const trimmedValue = get(changeEvent, 'target.value', '').trim();
        if (typeof onChangeCallback === 'function' && trimmedValue.length >= charactersMinLength) {
            onChangeCallback(changeEvent.target.value);
        }
        else if (typeof onResetCallback === 'function' && trimmedValue.length < charactersMinLength) {
            onResetCallback();
        }
    };
    // TODO: fix keyboard flow
    const onInputKeyUp = (event) => {
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation();
            if (focusedElementIndex === null || focusedElementIndex === 0) {
                setFocusedElementIndex(options.length - 1);
            }
            else {
                setFocusedElementIndex(focusedElementIndex - 1);
            }
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            if (focusedElementIndex === null || focusedElementIndex === options.length - 1) {
                setFocusedElementIndex(0);
            }
            else {
                setFocusedElementIndex(focusedElementIndex + 1);
            }
        }
        if (event.key === 'Enter' && focusedElementIndex !== null) {
            event.preventDefault();
            event.stopPropagation();
            setValue(name, options[focusedElementIndex].label);
            setIsListOpened(false);
            setFocusedElementIndex(null);
        }
    };
    const onSelect = (option) => {
        setValue(name, option.label);
        setIsListOpened(false);
        if (typeof onSelectCallback === 'function') {
            onSelectCallback(option);
        }
    };
    return (React.createElement(Controller, { control: control, name: name, render: ({ field: { onChange, value } }) => {
            const trimmedValue = (value || '').trim();
            return (React.createElement("div", { className: classnames('form-control input-autocomplete-control', controlClassName), ref: ref },
                label && (React.createElement("label", { htmlFor: name, className: "label" }, label)),
                React.createElement("div", { className: "form-control-wrapper input-autocomplete-wrapper" },
                    React.createElement("input", { type: "text", id: name, name: name, value: value, "data-testid": name, autoComplete: "off", disabled: disabled, placeholder: placeholder, className: classnames('input input-autocomplete', filled && 'filled', inputClassName, {
                            error: Boolean(errorText),
                        }), onChange: event => onInputChange(event, onChange), onFocus: () => setIsListOpened(true), onKeyUp: onInputKeyUp, inputMode: inputMode || null })),
                isListOpened && trimmedValue.length >= charactersMinLength && (React.createElement("div", { className: "autocomplete-list" },
                    !!options.length &&
                        !pending &&
                        options.map((option, index) => (React.createElement(InputAutocompleteOption, { key: index, option: option, searchText: trimmedValue, isFocused: focusedElementIndex === index, onSelect: onSelect }))),
                    !options.length && !pending && trimmedValue && (React.createElement(EmptyMessage, { text: tValidation('noResults') })),
                    pending && (React.createElement("div", { className: "loader" },
                        React.createElement(Skeleton, { marginBottom: 0, width: "90%", height: 26 }))))),
                errorText && (React.createElement("div", { className: "error", role: "alert" }, t(errorText, { amount: charactersMinLength })))));
        } }));
};

export { InputAutocomplete as I };
//# sourceMappingURL=InputAutocomplete-21f02xiu.js.map
